import { ReactNode } from 'react';

import { Box as Flex, Typography as Text } from '@material-ui/core';

import { Spinner } from '@spotify/confidence-core-react';

import styles from './PreviewShell.module.css';

interface PreviewShellProps {
  loading?: boolean;
  error?: unknown;
  children: ReactNode;
}

export const PreviewShell = ({
  loading,
  error,
  children,
}: PreviewShellProps) => {
  if (loading) {
    return (
      <div className={styles.loading}>
        <Spinner size={24} />
      </div>
    );
  }
  if (error) {
    return (
      <Text variant="body2" color="textSecondary">
        Could not load preview.
      </Text>
    );
  }
  return (
    <Flex
      display="flex"
      flexDirection="column"
      style={{
        gap: 'var(--encore-spacing-tighter)',
      }}
    >
      {children}
    </Flex>
  );
};
